import { atom } from 'recoil'
import { ILPConnectionRequest } from '@/pages/Equipment/equipment.types.ts'

interface IConnectionRequestsAtom {
  items: ILPConnectionRequest[]
  loaded: boolean
}

const connectionRequestsAtom = atom<IConnectionRequestsAtom>({
  key: 'connection-requests',
  default: {
    items: [],
    loaded: false,
  },
})
export default connectionRequestsAtom
